import { render, staticRenderFns } from "./SystemMessages.vue?vue&type=template&id=60317223&scoped=true&"
import script from "./SystemMessages.vue?vue&type=script&lang=js&"
export * from "./SystemMessages.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessages.vue?vue&type=style&index=0&id=60317223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60317223",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60317223')) {
      api.createRecord('60317223', component.options)
    } else {
      api.reload('60317223', component.options)
    }
    module.hot.accept("./SystemMessages.vue?vue&type=template&id=60317223&scoped=true&", function () {
      api.rerender('60317223', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/SystemMessages.vue"
export default component.exports